import Icon from '../components/Icon.vue'

Icon.register({"university":{"width":2048,"height":1792,"paths":[{"d":"M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/university.js